import { Card, CardContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function SettingsTab() {
  const { t } = useTranslation("members");

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography
          variant="h6"
          sx={{
            textTransform: "uppercase",
            fontWeight: 500,
            fontSize: "0.875rem",
            color: "text.secondary",
            mb: 2,
          }}
        >
          {t("settingsTab.title")}
        </Typography>
        <Typography color="text.secondary">
          {t("settingsTab.placeholder")}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default SettingsTab;
